import '../App.css';
import { Header, Button, Container, Segment, Input, Form, TextArea } from 'semantic-ui-react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { db } from "../utils/firebase";
import { set, ref } from "firebase/database";
import { trackSendingMessageEvent } from '../utils/analytics';


function ReplyForm(props) {

  const { sender, owner } = props;
  const [msgContent, setMsgContent] = useState("");

  const reset = () => {
    setMsgContent("");
  }

  const isValid = () => {
    return msgContent && msgContent.length > 0
  }

  const onMsgContentChange = (event) => {
    setMsgContent(event.target.value);
  }

  const onSendClick = () => {
    const message = {
      aliasA: sender,
      aliasB: owner,
      content: msgContent,
      time: new Date().getTime()
    }

    const chatIdArray = [message.aliasA, message.aliasB]
    chatIdArray.sort();
    const chatId = chatIdArray[0] + "_" + chatIdArray[1];

    set(ref(db, 'chats/' + chatId + "/" + Date.now()), message).then(res => {

      //updating links
      set(ref(db, `chatLinks/${message.aliasA}/${message.aliasB}`), true)
        .then(() => { })
      set(ref(db, `chatLinks/${message.aliasB}/${message.aliasA}`), true)
        .then(() => { })

      reset();
      trackSendingMessageEvent();
    }).catch(() => { });

    console.log(JSON.stringify(message));
  }

  return (
    <Container textAlign='center'>
      <Segment>
        <Container className="standardMargin">
          <Form>
            <TextArea onChange={onMsgContentChange} placeholder='Tvoja správa' value={msgContent} />
          </Form>
        </Container>
        <Button disabled={!isValid()} onClick={onSendClick} positive>Poslať</Button>
      </Segment>
    </Container>
  );
}

export default ReplyForm;
